export default "__VITE_ASSET__Cimyz$vM__"